<template>
  <el-container id="app-main" v-loading="loading">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </el-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { app } from '@/store';

export default defineComponent({
  name: 'AppMain',
  computed: {
    loading() {
      return app.isLoading;
    },
  },
});
</script>

<style lang="scss" scoped>
#app-main {
  width: 100%;
  height: calc(100vh - 82px);
  /* 84 = navbar + tags-view = 45 + 37 */
  position: relative;
  overflow: auto;
}
</style>
